module.exports = __webpack_public_path__ + "static/img/smuggler2.b341e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/smuggler2.png
// module id = XP97
// module chunks = 0